import {
  AboveGradeWallType,
  BelowGradeWallType,
  ExposureDirectionType
} from 'data/types';
import { EdgeCardinal } from 'utils/space-polygon';
import { getOrientedEdge } from 'utils/structure';

export function wallCardinal(
  wall: AboveGradeWallType | BelowGradeWallType,
  homeOrientation: ExposureDirectionType | undefined
): EdgeCardinal | undefined {
  if ('edge' in wall && wall.edge) {
    return wall.edge;
  }
  return getOrientedEdge(wall.exposure, homeOrientation);
}
